import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginForm } from './components/LoginForm';
import { RegisterForm } from './components/RegisterForm';
import MapLibreMapPage from './pages/MapLibreMapPage';
import MapV2Page from './pages/MapV2Page';
import LandingPage from './pages/LandingPage';
import { isAuthenticated } from './services/auth';

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page */}
        <Route path="/" element={<LandingPage />} />

        {/* Public routes */}
        <Route
          path="/login"
          element={
            isAuthenticated() ? <Navigate to="/map" replace /> : <LoginForm />
          }
        />
        <Route
          path="/signup"
          element={
            isAuthenticated() ? <Navigate to="/map" replace /> : <RegisterForm />
          }
        />

        {/* Protected routes */}
        <Route
          path="/map"
          element={
            <ProtectedRoute>
              <MapLibreMapPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/map/v2"
          element={
            <ProtectedRoute>
              <MapV2Page />
            </ProtectedRoute>
          }
        />

        {/* Catch all redirect */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
